import {Link,useLocation} from 'react-router';
import {useWorkspaceSession} from './StaffSession';
import {Icon,navigationIcon} from './Icon';
import {dashboardProfiles} from './dashboard-profiles';
export const dashboardWorkspacePath=(path:string)=>path==='/dashboards'||path.startsWith('/dashboards/');
export function DashboardWorkspaceRail(){
 const location=useLocation(),session=useWorkspaceSession()!;if(!dashboardWorkspacePath(location.pathname))return null;
 return <nav className="workspace-family-navigation dashboard-family-navigation" aria-label="Dashboard navigation"><ul><li><Link to="/dashboards" aria-current={location.pathname==='/dashboards'?'page':undefined}><Icon name="layout-dashboard"/>
<span>Dashboards</span>
</Link></li>{dashboardProfiles(session).map(profile=><li key={profile.href}><Link to={profile.href} aria-current={location.pathname===new URL(profile.href,'https://staff.invalid').pathname&&location.pathname!=='/'?'page':undefined}><Icon name={navigationIcon(profile.title)}/>
<span>{profile.title}</span>
</Link></li>)}</ul></nav>;
}
